<template>
  <div>
    <Filters
      :status="currentStatus"
      @change="updateFilters"
    />

    <Table
      :items="items"
      :pagination="pagination"
      :status="currentStatus"
      :activeTab="activeTab"
      @reloadData="reloadData"
      @goToPage="updatePage"
      @addChargebackRide="openChargebackRideDialog"
      @editChargebackRide="openChargebackRideDialog"
      @deleteChargeback="openDeleteChargebackDialog"
    />

    <ChargebackRideDialog
      :visible="chargebackRideDialog"
      :type="dialogType"
      :data="selectedItem"
      @close="closeChargebackRideDialog"
    />

    <DeleteChargebackDialog
      :visible="deleteChargebackDialog"
      :data="selectedItem"
      @close="closeDeleteChargebackDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray, isObject } from 'utils/functions'
import Filters from 'components/financialAdjustments/FiltersRide'
import Table from 'components/financialAdjustments/TableRide'
import ChargebackRideDialog from 'components/financialAdjustments/dialogs/ChargebackRideDialog'
import DeleteChargebackDialog from 'components/financialAdjustments/dialogs/DeleteChargebackDialog'

export default {
  name: 'TabRide',
  props: {
    activeTab: {
      type: Number
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Filters,
    Table,
    ChargebackRideDialog,
    DeleteChargebackDialog
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.FinancialAdjustmentsPage',
      pagination: {},
      filters: {
        search: null
      },
      currentStatus: null,
      items: [],
      dialogType: null,
      selectedItem: null,
      chargebackRideDialog: false,
      deleteChargebackDialog: false
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    },

    renderData (data) {
      if (this.isValidObject(data)) {
        this.currentStatus = data.status ? data.status : null
        this.items = this.isValidArray(data.tableBody) ? data.tableBody : []
        this.pagination = data.pagination ? { ...data.pagination } : {}
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.$emit('updateFilters', this.filters)
      this.reloadData()
    },

    resetPagination () {
      this.$emit('resetPagination')
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.$emit('updatePagination', this.pagination)
      this.loadData()
    },

    loadData () {
      this.$emit('loadData')
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    },

    openChargebackRideDialog ({ data, type = 'create' }) {
      this.dialogType = type
      this.selectedItem = data
      this.chargebackRideDialog = true
    },

    closeChargebackRideDialog (reload) {
      if (reload) {
        const tab = this.dialogType === 'create' ? 1 : this.activeTab
        this.reloadData()
        this.$emit('changeTab', tab)
      }

      this.dialogType = null
      this.selectedItem = null
      this.chargebackRideDialog = false
    },

    openDeleteChargebackDialog (val) {
      this.selectedItem = val
      this.deleteChargebackDialog = true
    },

    closeDeleteChargebackDialog (reload) {
      this.selectedItem = null
      this.deleteChargebackDialog = false
      if (reload) {
        this.reloadData()
        this.$emit('changeTab', 0)
      }
    }
  },

  watch: {
    data: {
      deep: true,
      handler (val) {
        this.renderData(val)
      }
    }
  }
}
</script>
